import React, { useState } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";

const Nav = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const close = () => setOpen(false);

  return (
    <nav className="nav">
      <button
        className={`hamburger ${open ? "open" : ""}`}
        onClick={() => setOpen(!open)}
        aria-label="Menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
      <Link to="/" className="nav-logo" onClick={close}>
        People<span>ology</span>
      </Link>
      <ul className={`nav-links ${open ? "open" : ""}`}>
        <li><NavLink to="/" end onClick={close}>Home</NavLink></li>
        <li><NavLink to="/services" onClick={close}>Services</NavLink></li>
        <li><NavLink to="/recruitment" onClick={close}>Recruitment</NavLink></li>
        <li><NavLink to="/speaking" onClick={close}>Speaking</NavLink></li>
        <li><NavLink to="/about" onClick={close}>About</NavLink></li>
        <li><NavLink to="/contact" onClick={close} className="nav-btn">Connect</NavLink></li>
      </ul>
    </nav>
  );
};

export default Nav;
